import { ContentState, convertFromHTML, EditorState, Modifier } from "draft-js"
import { Dispatch, SetStateAction } from "react"

export const handlePastedText = (
  html: string,
  editorState: EditorState,
  setEditorState: Dispatch<SetStateAction<EditorState>>
) => {
  if (!html) return false // no HTML content, fallback to default paste behavior

  // parse the pasted HTML to a DOM structure
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, "text/html")

  // find all <img> elements in the pasted HTML
  const imgTags = doc.querySelectorAll("img")
  if (imgTags.length === 0) return false // No <img> tags, use default behavior

  // remove all <img> tags from the DOM
  imgTags.forEach((img) => img.remove())

  // get the cleaned HTML (without <img> tags)
  const cleanedHTML = doc.body.innerHTML

  // convert cleaned HTML to Draft.js content blocks and entity map
  const blocksFromHTML = convertFromHTML(cleanedHTML)
  const contentBlocks = blocksFromHTML.contentBlocks
  const entityMap = blocksFromHTML.entityMap

  // get the current content and selection in the editor
  const contentState = editorState.getCurrentContent()
  const selection = editorState.getSelection()

  // create new content state by inserting the cleaned blocks at the selection
  const newContentState = Modifier.replaceWithFragment(
    contentState,
    selection,
    ContentState.createFromBlockArray(contentBlocks, entityMap).getBlockMap()
  )

  // push the new content state into a new editor state
  const newEditorState = EditorState.push(
    editorState,
    newContentState,
    "insert-fragment"
  )

  // update the editor with the new state
  setEditorState(newEditorState)

  // prevent default paste behavior since we handled it manually
  return true
}
